module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.0ccdd1c3.ttf";